/**
 * A API passa a devolver campos monetários/quantidade como string decimal
 * (para não perder precisão em notação científica). Este helper centraliza o
 * parse defensivo desses valores, aceitando tanto o formato antigo (number)
 * quanto o novo (string), para uso em formatação, comparação e aritmética.
 */
export function toNumber(value: string | number | null | undefined): number {
  if (typeof value === "number") return value;
  if (value == null) return 0;
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : 0;
}
